import React from 'react';
import { Check, Clock } from 'lucide-react';

interface ListItemProps {
  isCompleted: boolean;
  children: React.ReactNode;
}

export function ListItem({ isCompleted, children }: ListItemProps) {
  return (
    <li
      className={`grid min-h-[48px] grid-cols-[1fr_24px] items-center gap-1 rounded-2xl border border-accent px-[18px] ${isCompleted ? 'border-solid bg-accent text-foreground' : 'border-dashed bg-blue-light text-accent'}`}
    >
      {children}
      {isCompleted ? <Check size={24} /> : <Clock size={24} />}
    </li>
  );
}
